import { render, staticRenderFns } from "./LowSalesAuthorizationNotice.vue?vue&type=template&id=5ab3dc3a&scoped=true"
import script from "./LowSalesAuthorizationNotice.vue?vue&type=script&lang=js"
export * from "./LowSalesAuthorizationNotice.vue?vue&type=script&lang=js"
import style0 from "./LowSalesAuthorizationNotice.vue?vue&type=style&index=0&id=5ab3dc3a&prod&scoped=true&lang=css"
import style1 from "./LowSalesAuthorizationNotice.vue?vue&type=style&index=1&id=5ab3dc3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3dc3a",
  null
  
)

export default component.exports